// src/pages/ChartPage.jsx
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './ChartPage.css';

const ChartPage = () => {
  const [chartHtml, setChartHtml] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const location = useLocation();
  const navigate = useNavigate();
  
  // Get URL from query params or state
  const chartUrl = location.state?.chartUrl || new URLSearchParams(location.search).get('url');
  const gameName = location.state?.gameName || 'Chart';

  useEffect(() => {
    if (!chartUrl) {
      setError('No chart URL provided');
      setLoading(false);
      return;
    }

    const fetchChart = async () => {
      try {
        setLoading(true);
        const response = await fetch(chartUrl);
        
        if (!response.ok) {
          throw new Error(`Failed to load chart: ${response.status}`);
        }
        
        const html = await response.text();
        setChartHtml(html);
        setError('');
      } catch (err) {
        console.error('Error fetching chart:', err);
        setError('Failed to load chart. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchChart();
  }, [chartUrl]);

  return (
    <div className="chart-page">
      <div className="chart-header">
        <button onClick={() => navigate(-1)} className="back-btn">
          ← Back
        </button>
        <h2>{gameName} - Chart</h2>
        <div></div> {/* Spacer for flex alignment */}
      </div>

      <div className="chart-container">
        {loading ? (
          <div className="loading-chart">
            <div className="spinner"></div>
            <p>Loading chart...</p>
          </div>
        ) : error ? (
          <div className="error-chart">
            <p>{error}</p>
          </div>
        ) : (
          // Render the fetched HTML content
          <div 
            dangerouslySetInnerHTML={{ __html: chartHtml }}
            className="chart-content"
          />
        )}
      </div>
    </div>
  );
};

export default ChartPage;